export const australiaStateOptions = [
  { ID: "ACT", name: "Australian Capital Territory" },
  { ID: "NSW", name: "New South Wales" },
  { ID: "NT", name: "Northern Territory" },
  { ID: "QLD", name: "Queensland" },
  { ID: "SA", name: "South Australia" },
  { ID: "TAS", name: "Tasmania" },
  { ID: "VIC", name: "Victoria" },
  { ID: "WA", name: "Western Australia" },
];
